import { z } from 'zod';

export const substageSchema = z.object({
  stage_id: z.string().uuid(),
  name: z.string().min(1, 'Substage name is required'),
  description: z.string().optional(),
  priority: z.enum(['low', 'medium', 'high']).default('medium'),
  start_date: z.string().optional(),
  end_date: z.string().optional(),
  estimated_hours: z.number().min(0, 'Estimated hours must be 0 or greater').optional(),
  assigned_user_id: z.string().uuid().optional()
});

export type SubstageFormData = z.infer<typeof substageSchema>;